angular.module('dnecom')
    .directive('uploadImageHelper', function () {
        return {
            type: 'EA',
            replace: true,
            scope: {
                sizeX: '@',
                sizeY: '@',
                width: '@',
                extension: '@',
                title: '@'
            },
            template: '<div style="width: {{ width || 100 }}px;" class="upload-image-helper">\n    <div class="upload-image-helper-rule upload-image-helper-rule-horizontal">\n        <span>{{ sizeX || \'100px\' }}</span>\n    </div>\n    <div class="upload-image-helper-rule upload-image-helper-rule-vertical">\n        <span>{{ sizeY || \'100px\' }}</span>\n    </div>\n    <div class="upload-image-helper-inner">\n        <p ng-if="title" class="upload-image-helper-inner-title">{{ title }}</p>\n        <p class="upload-image-helper-inner-extension">{{ extension || \'.jpg, .png\' }}</p>\n    </div>\n</div>'
        }
    });
